
import _, { intersection, map } from 'lodash';
import Style from 'ol/style/Style';
import {Vector as VectorLayer } from 'ol/layer';
import {Fill} from 'ol/style';
import React from 'react';
import { getUpdatedActiveIndex } from 'react-bootstrap-typeahead/types/utils';
import {level_arr,featureName,HeatMap_url} from '../../Essentials/variables';
import { getLevel } from '../../Essentials/common_fn';
const heatMapColor = {"Coverage" : {
    'red' : 'rgb(210, 34, 45, 0.5)',
    'yellow' : 'rgb(255, 191, 0, 0.5)',
    'green' : 'rgb(35, 136, 35, 0.5)',
    'black' : 'rgb(0,0,0,0.5)',
    'purple':'rgb(128,0,128,0.5)'
    },
    // "potential" : {
    //     'magenta' : 'rgb(255,0,255,0.5)',
    //     'cyan' : 'rgb(0,255,255, 0.5)',
    //     'crimson' : 'rgb(220,20,60, 0.5)'
    //     },
    "potential":{
        'green' : 'rgb(35, 136, 35, 0.5)',
        'yellow' : 'rgb(255, 191, 0, 0.5)',
        'red' : 'rgb(210, 34, 45, 0.5)',
        'blue' : 'rgb(173, 216, 230,0.5)',
        'black' : 'rgb(0,0,0,0.5)'
    },
    'default' : 'rgb(0,0,0,0.01)'
}


var base_url = HeatMap_url;

function getUrl(dataset, selection, year, month, type) { //api databse routing
    var prefix;
    console.log("Year output-> ", year, " Month: ", month);
    if (type!='employee') {
        prefix = 'inc';
    }
    // ASM-298 Updates
    else if ((year > 2024 && month >= 4) || year >= 2025) {
        prefix = 'inc';
    }
    else {
        prefix = 'dms';
    }
    var ret = base_url + '/' + dataset + "/" + prefix + "/" + year + "/" + month + "/" + type;
    var level = getLevel(selection);
    for (var i = 0; i <= _.indexOf(level_arr, level); i++) {
        ret = ret + '/' + _.replace(selection[level_arr[i]], / /g, '');
    }
    console.log("URL:", ret);
    return ret;
}

async function getHeatMapData(dataset,selected,year,month,type){
    console.log(year+" "+month+" "+type);
    if(dataset !== "Nil"){
        let url = getUrl(dataset,selected,year,month,type);
        // console.log(url);
        let Token=localStorage.getItem('token')
        // console.log(Token);
        let data = await fetch(url,{
            
            headers:{
                "x-access-token":Token,
                'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Frame-Options': 'DENY',
                        'Content-Security-Policy': "frame-ancestors 'none'",
                        'Feature-Policy': "frame-ancestors 'none'"
            }
        });
        // console.log("Print false data ",data?.status);

    return data; //status
    }else{
        return "DEFAULT";
    }
    
}
//State,District,Sub_District,Village,curr_yr_coverage,covered_prev_yr_but_not_this_yr,covered_this_yr_but_not_prev_yr,cumulative_coverage
function getColor(dataset,f,data){
    let colors = heatMapColor[dataset];

    let featureData = {
        'state' : f.get('STATE_NAME'),
        'district' : _.replace(f.get('DIST_NAME')," District","") ,
        'subdistrict' : f.get('SUBDIST_NAME'),
        'village' : f.get('VIL_NAME')
    }
    // console.log(_.find(data,featureData));
    let obj = _.find(data,featureData);
    if(!_.isUndefined(obj) || !_.isEmpty(obj)){

    
    if(dataset === "Coverage"){
// [00]Never Covered (never in 8yrs) :- Grey 
// [01]Covered in this yr (never in all prev yr but only this yr) :- Yellow
// [10]Covered in any of prev yr but not this yr :- Red
// [11]Covered in any prev yr and also this yr :- Green
        
        // if(obj["covered_this_yr_but_not_prev_yr"] === 'Yes'){
        //         return colors.yellow;
        // }else if(obj["covered_prev_yr_but_not_this_yr"] === 'Yes'){
        //     return colors.red;
        // }else if(obj["curr_yr_coverage"] === 'Yes' && obj["covered_this_yr_but_not_prev_yr"]==='No'){
        //     return colors.green;
        // }else if(obj["cumulative_coverage"] === 'No'){
        //     return colors.black;
        // }
    //     if(obj["covered_this_yr_but_not_prev_yr"] === 'Yes'){
    //         return colors.yellow;
    //     }else if(obj["covered_prev_yr_but_not_this_yr"] === 'Yes'){
    //     return colors.red;
    //     }else if(obj["covered_this_also_prev_year"] === 'Yes'){
    //     return colors.green;
    //    }else {
    //     return colors.black;
    //    }
           if(obj["covered_this_also_prev_year"] === 'Yes'){
             return colors.green;
           }else if(obj["covered_this_yr_but_not_prev_yr"] === 'Yes'){
                return colors.yellow;
            }
            if(obj["covered_prev_yr_but_not_this_yr"] === 'Yes'){
                return colors.red;
            }
            if(obj["fifth_colour"]==='Yes'){
               return colors.purple;
            }
             else {
                return colors.black;
            }
        
    }
            // currentObject.covered_prev_yr_but_not_this_yr = 'No';
            // currentObject.covered_this_also_prev_year = 'No';
            // currentObject.covered_this_yr_but_not_prev_yr = 'Yes'; 
    if(dataset === "potential"){
        
        // 1 = High Potential (Uncovered Village) - Green
        // 2 = Medium Potential (Uncovered Village) - Yellow
        // 3 = Low Potential (Uncovered Village) - Red
        // 4 = Covered Villages - Blue
        console.log('potential inside',obj["potential"])
        if(obj["potential"] === 1){
            return colors.green;
            //return colors.magenta;
        }else if(obj["potential"] === 2){
            return colors.yellow;
            //return colors.cyan;
        }else if(obj["potential"] === 3){
            return colors.red;
            //return colors.crimson;
        }else if(obj["potential"] === 4){
            return colors.blue;
            //return colors.crimson;
        }
        else{
            return heatMapColor.default;
        }
    }
}else{
    return heatMapColor.default;
}

}



export function updateHeatMap(dataset,selected,stateData,setStateData,loader,setLoader,setCount,year,month,type){
    if(!_.isEmpty(selected.Sub_District)){
        setLoader({...loader,'active':true,'content':'Loading '+dataset+' Heatmap'});
        
        getHeatMapData(dataset,selected,year,month,type).then((response) => response === "DEFAULT" ? {} : response.json()).then((data)=>{
            console.log("heatmap Data",data);
            let c = {}
            if(!_.isUndefined(data) && !_.isEmpty(data)){
            if('potential' in _.first(data)){
                c[1] =  _.filter(data,(item)=>{return item.potential === 1}).length;
                c[2] =  _.filter(data,(item)=>{return item.potential === 2}).length;
                c[3] =  _.filter(data,(item)=>{return item.potential === 3}).length;
                c[4] =  _.filter(data,(item)=>{return item.potential === 4}).length;
            }else{
                c[1] =  _.filter(data,(item)=>{return item?.covered_prev_yr_but_not_this_yr === "Yes"}).length;
                c[2] =  _.filter(data,(item)=>{return item?.covered_this_yr_but_not_prev_yr === "Yes"}).length;
                c[3] =  _.filter(data,(item)=>{return item?.covered_this_also_prev_year === 'Yes'}).length;
                c[4] =  _.filter(data,(item)=>{return item?.cumulative_coverage === "No"}).length;
                c[5] =  _.filter(data,(item)=>{return item?.fifth_colour === "Yes"}).length;
            }
                        // currentObject.covered_prev_yr_but_not_this_yr = 'No';
            // currentObject.covered_this_also_prev_year = 'No';
            // currentObject.covered_this_yr_but_not_prev_yr = 'Yes'; 
            //cumulative_coverage
            setCount(c);
        }
            let map = stateData.mapObject;
            console.log("Guruji0", stateData);
            try{
                map?.getAllLayers().forEach((l) =>  
            {   //console.log(l.getSource());
                if(l instanceof VectorLayer){
                    console.log("Guruji1", l);
                    //console.log(l.getSource());
                    let url = l?.getSource()?.url_?.split("/");
                    console.log("URL ",url);
                    console.log("Guruji StateData",stateData.selected);
                    
                if(_.includes(url,'getboundary') || _.includes(url,'newgetboundary')){
                    console.log("Guruji2", url);
                    //console.log(l.getSource().getFeatures());
                    let flf = l.getStyleFunction();
                    l.getSource()?.getFeatures()?.forEach((f)=>{
                        let flf_o = flf(f);
                    //    console.log("Guruji3",dataset)
                        if(dataset !== "Nil"){
                            // console.log("Guruji4", stateData);
                            f.setStyle(new Style({
                                fill : new Fill({
                                        color: getColor(dataset,f,data),
                                    }),
                                text: flf_o.getText(),
                                stroke: flf_o.getStroke(),
                        }));
                        }else{
                            f.setStyle(new Style({
                                fill : new Fill({
                                        color: 'rgb(0,0,0,0.01)',
                                    }),
                                text: flf_o.getText(),
                                stroke: flf_o.getStroke(),
                        }));
                        }
                        
                    });
                }
                }
                setLoader({...loader,'active':false});
            
            }
            );
            }
           catch(err){
            console.log(err);
           }
        
            setStateData({...stateData,'mapObject' : map});
        });
    }
        
    
}



